import { useOnline } from "@/lib/useOnline";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";

/**
 * OfflineBanner — vises alltid når brukaren er offline ELLER når vi har
 * ventande mutasjonar. Kompakt, sticky-topp banner.
 */
export default function OfflineBanner() {
  const { online, pendingCount, syncing, syncNow } = useOnline();
  if (online && pendingCount === 0) return null;
  return (
    <div
      className={`sticky top-0 z-40 w-full ${!online ? "bg-red-600" : "bg-amber-600"} text-white text-xs px-3 py-1.5 flex items-center justify-between gap-2`}
      data-testid="offline-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        {!online ? (
          <><WifiOff className="h-3.5 w-3.5 flex-shrink-0" /><span className="truncate">Du er offline — endringar blir lagra lokalt og synka når du er tilbake</span></>
        ) : (
          <><CloudUpload className="h-3.5 w-3.5 flex-shrink-0" /><span className="truncate">{pendingCount} endring{pendingCount === 1 ? "" : "ar"} ventar på synkronisering</span></>
        )}
      </div>
      {online && pendingCount > 0 && (
        <button
          onClick={syncNow}
          disabled={syncing}
          className="inline-flex items-center gap-1 rounded bg-white/20 hover:bg-white/30 px-2 py-0.5 text-[11px] font-semibold disabled:opacity-50 flex-shrink-0"
          data-testid="sync-now-btn"
        >
          <RefreshCw className={`h-3 w-3 ${syncing ? "animate-spin" : ""}`} />
          {syncing ? "Synkar…" : "Synk no"}
        </button>
      )}
    </div>
  );
}
